import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import ImageWithEditIcon from './Editimage';


const initial = {
    name:"",
    date:"",
    description:"",
    location:"",
    price:"",
}

const UpdateEvent = () => {
  const {id} = useParams()
    const [userData,setUserData] = useState(initial)
    const [btnLoading,setBtn] = useState(false)
    const [currImgUrl,setCurrUrl] = useState("")
    
    const fileInputRef = useRef(null);

    const handleEditIconClick = () => {
        fileInputRef.current.click(); 
    };
    const handleChange =(e) =>{
        const { name, value } = e.target;
        if(name==="image"){
          setUserData({ ...userData, [name]: e.target.files[0] });
        }
        else{
          setUserData({ ...userData, [name]: value });

        }
        
    }


    const handleSubmit = async(e)=>{
        e.preventDefault()
        console.log(userData);
        setBtn(true)
        const formData = new FormData()
        Object.entries(userData).forEach(([key, value]) => {
          formData.append(key, value);
      });
      for(let i of formData){
        console.log(i)
      }
      // return
    const requestOptions = {
      method: "PATCH",
      headers: {
        "authentication":localStorage.getItem('token_chirag')
      },
      body: formData,
    };
        try {
          await fetch(`http://localhost:5000/event-update/${id}`,
          requestOptions
          ).then((res)=>{
            if(!res.ok){
              throw new Error(`something went wrong`)
            }
            return res.json()
          })
          .then((data)=>{
            console.log(data);
            setBtn(false)
            setUserData(initial)

            toast.success('Event Updated succesfully 🎉🎉', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              });
          })
        } catch (error) {
          console.log(error);
          toast.error('Something went wrong!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            }); 
        }

    }
    const fetchData = async () => {
      try {
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "authentication":localStorage.getItem('token_chirag')
          },
        };
        const res = await fetch(`http://localhost:5000/event/${id}`,requestOptions);
        const {event} = await res.json();
        console.log(event);
        setUserData(event)
        setCurrUrl(event.image)

      } catch (error) {
        console.log(error);
      }
    };
    useEffect(()=>{
      fetchData()
    },[])

    const handleImageChange = (e) => {
      handleChange(e)
      const file = e.target.files[0];
      if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
              const imageUrl = event.target.result;
              setCurrUrl(imageUrl)
          };
          reader.readAsDataURL(file);
      }
     
  };
  return (
    <div className="wrapper">
  <h1>Update Event</h1>
  <div style={{ position: 'relative', display: 'inline-block' }}>
            <img src={currImgUrl} alt="Image" style={{ maxWidth: '100%' }} />
            <div onClick={handleEditIconClick} style={{
                position: 'absolute',
                top: 10,
                right: 10,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                padding: '5px',
                borderRadius: '50%',
                cursor: 'pointer'
            }}>
               <svg  class="feather feather-edit" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
               <input
                type="file"
                id="fileInput"
                name='image'
                style={{ display: 'none' }}
                ref={fileInputRef}
                accept="image/*"
                onChange={(e) => {
                  handleImageChange(e)
                }}
            />
            </div>
        </div>
  <form onSubmit={handleSubmit}>
    <label htmlFor="eventName">Event Name:</label>
    <input type="text" id="eventName" name="name" required value={userData.name} onChange={(e)=>handleChange(e)}/>

    <label htmlFor="eventDate">Date:</label>
    <input type="date" id="eventDate" name="date" required value={userData.date} onChange={(e)=>handleChange(e)} />

    <label htmlFor="eventLocation">Location:</label>
    <input type="text" id="eventLocation" name="location" value={userData.location} required onChange={(e)=>handleChange(e)} />

    <label htmlFor="eventDescription">Description:</label>
    <textarea id="eventDescription" name="description" required value={userData.description} onChange={(e)=>handleChange(e)}></textarea>

    
    <label htmlFor="eventPrice">Price:</label>
    <input type="number" id="eventPrice" name="price" required value={userData.price} onChange={(e)=>handleChange(e)} />

    <button type="submit">{btnLoading?"Loading...":"Update Event"}</button>
  </form>
  <ToastContainer />
</div>

  )
}

export default UpdateEvent